import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Spinner } from "@masterteam/mt-design-react";

import Table from "../../NewTable";
import WorkflowModal from "../WorkflowModal";

import api from "../../../providers/api";
import useIsAr from "../../../Hooks/useIsAr";
import { addToast, getLookupName } from "../../../helpers";

import { ReactComponent as HistoryIcon } from "../../../assets/images/history.svg";

import "./style.scss";

const initialModalState = {
  isOpen: false,
  data: null,
};

const MyRequests = () => {
  const intl = useIntl();
  const [isAr] = useIsAr();
  const history = useHistory();
  const [workflowModal, setWorkflowModal] = useState(initialModalState);

  const [TaskCenterActions, BaseWorkflowTypes, WorkflowStatus] = useSelector(
    ({ theme }) => [
      theme.TaskCenterActions.item.Items.filter((e) => e.Value !== "All"),
      theme.BaseWorkflowTypes.item.Items,
      theme.WorkflowStatus.item.Items,
    ]
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contentLoading, setContentLoading] = useState(true);

  const handleOnClick = (item) => {
    if (item.Level === 1) history.push(`/splus/kpi-details/${item?.LevelID}`);
  };

  const getData = async (newKey) => {
    try {
      setLoading(!newKey);
      setContentLoading(true);

      const res = await api.taskCenter.getMyRequests();

      setData(res?.Data || []);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
      setContentLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      key: "request-type",
      header: <FormattedMessage id="my-requests.request-type" />,
      cell: (item) => {
        return item?.Action === 2
          ? getLookupName(TaskCenterActions, item?.Action.toString(), isAr)
          : getLookupName(
              BaseWorkflowTypes,
              item?.BaseWorkflowID.toString(),
              isAr
            );
      },
      width: "15%"
    },
    {
      key: "kpi-name",
      header: <FormattedMessage id="common.kpi-name" />,
      cell: (item) => (isAr ? item.ArabicName : item?.EnglishName) || "---",
      width: "20%"
    },
    {
      key: "creation-date",
      header: <FormattedMessage id="my-requests.creation-date" />,
      cell: (item) =>
        item.Created ? moment(item.Created).format("DD-MM-YYYY") : "---",
      width: "20%"
    },
    {
      key: "creator",
      header: <FormattedMessage id="my-requests.creator" />,
      cell: (item) => item.CreatedBy?.DisplayName || "---",
      width: "15%",
    },
    {
      key: "workflow",
      header: <FormattedMessage id="my-requests.workflow" />,
      cell: (item) => (
        <div className="icon-wrapper">
          <HistoryIcon
            onClick={(e) => {
              e.stopPropagation();
              setWorkflowModal({ isOpen: true, data: item.Request });
            }}
          />
        </div>
      ),
      width: "15%",
    },
    {
      key: "status",
      header: <FormattedMessage id="my-requests.status" />,
      cell: (item) =>
        getLookupName(WorkflowStatus, item?.Status.toString(), isAr),
      width: "15%"
    },
  ];

  return loading ? (
    <Row justify="center" style={{ marginTop: "24px" }}>
      <Spinner size="large" />
    </Row>
  ) : (
    <div>
      {contentLoading ? (
        <Row justify="center" style={{ marginTop: "24px" }}>
          <Spinner size="large" />
        </Row>
      ) : (
        <Table
          compact
          data={data || []}
          columns={columns}
          differentRowsColor
          headerHasBackgroundColor
          onClickItem={handleOnClick}
        />
      )}

      {workflowModal.isOpen && (
        <WorkflowModal
          data={workflowModal.data}
          onClose={() => setWorkflowModal(initialModalState)}
        />
      )}
    </div>
  );
};

export default MyRequests;
